import React from 'react';
import { IconButton, DialogTitle, Dialog } from '@mui/material';
import { Close } from '@mui/icons-material';

export default function SimplePDFViewer({ open, file, onClose }) {
  return (
    <Dialog
      fullWidth
      maxWidth={false}
      classes={{ paper: 'h-full' }}
      open={open}
    >
      <div className="flex justify-between items-center">
        <DialogTitle>PDF 預覽</DialogTitle>
        <IconButton className="mr-4" onClick={onClose} color="error">
          <Close />
        </IconButton>
      </div>
      <iframe
        src={file}
        width="100%"
        height="100%"
        style={{ border: 'none' }}
        title="PDF 預覽"
      />
    </Dialog>
  );
}
